export const transformCart = (cart) => {
    return {
        ...cart,
        items: [...cart.items].map((item) => ({
            ...item,
            RATE: item.RATE ? parseFloat(item.RATE) : null,
        })),
    };
};
